var React = require('react');

function FlagTz (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 344.276V97.103a8.829 8.829 0 018.828-8.828h379.586L0 344.276z","fill":"#73af00","key":0}),React.createElement("path",{"d":"M512 167.724v247.172a8.829 8.829 0 01-8.828 8.828H123.586l388.414-256z","fill":"#4173cd","key":1}),React.createElement("path",{"d":"M512 172.702V97.103a8.829 8.829 0 00-8.828-8.828H383.139L0 339.298v75.598a8.829 8.829 0 008.828 8.828h120.033L512 172.702z","fill":"#ffe15a","key":2}),React.createElement("path",{"d":"M512 141.047V97.103a8.829 8.829 0 00-8.828-8.828h-71.718L0 370.953v43.944a8.829 8.829 0 008.828 8.828h71.718L512 141.047z","fill":"#464655","key":3})]);
}

FlagTz.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = FlagTz;

FlagTz.default = FlagTz;
